import { render, staticRenderFns } from "./SalesReportDetails.vue?vue&type=template&id=38212a9a&"
import script from "./SalesReportDetails.vue?vue&type=script&lang=ts&"
export * from "./SalesReportDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports